// import './SectionHeading.css'


const SectionHeading = ({p,h2}) => { 

return(

<div className='SectionHeading'>
<p className='subtitle'>{p}</p>
<h2 className='sectionTitle'>{h2}</h2>
</div>

)
}

export default SectionHeading